import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActivitiesService } from 'src/app/services/activities-services/activities.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { catchError, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

@Component({
  selector: 'app-activities-sms-consumption-dashboard',
  templateUrl: './activities-sms-consumption-dashboard.component.html',
  styleUrls: ['./activities-sms-consumption-dashboard.component.scss']
})
export class ActivitiesSmsConsumptionDashboardComponent implements OnInit, OnDestroy {

  smsConsumptionList;
  private getSmsConsumptionSubscription: Subscription;
  private listenSmsConsumptionSearchSubscription: Subscription;

  constructor(private activitiesService: ActivitiesService,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    const datetimeFrom = new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0).getTime();
    const datetimeTo = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59.999).getTime();
    this.getSmsConsumption(datetimeFrom, datetimeTo);
    this.setBreadcrumb();
    this.listenSmsConsumptionSearch();
  }

  private getSmsConsumption(datetimeFrom, datetimeTo) {
    this.getSmsConsumptionSubscription = this.activitiesService.getSmsConsumptionList(datetimeFrom, datetimeTo).pipe(
      tap(o => this.smsConsumptionList = o),
      tap(o => this.activitiesService.smsConsumptionRefresh(this.smsConsumptionList)),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private listenSmsConsumptionSearch() {
    this. listenSmsConsumptionSearchSubscription = this.activitiesService.listenSmsConsumptionSearch().pipe(
      tap(o => this.getSmsConsumption(o['dateFrom'], o['dateTo']))
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-chart-line', 'activity-page.sms consumption', '/account/activity', [new BRoute('account-page.account', '/account'), new BRoute('activity-page.activity', '/account/activity'), new BRoute('activity-page.sms consumption')]));
  }

  ngOnDestroy() {
    if (this.getSmsConsumptionSubscription) { this.getSmsConsumptionSubscription.unsubscribe(); }
    if (this.listenSmsConsumptionSearchSubscription) { this.listenSmsConsumptionSearchSubscription.unsubscribe(); }
  }
}
